/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import Button from "../../component/button/Button";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import SelectInput from "../../component/input/SelectInput";
import TextInput from "../../component/input/TextInput";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";

const CreateRulesModal = ({
  values,
  loading,
  onChange,
  locations,
  inTimeString,
  outTimeString,
  onCreateRulesSubmit,
  showShiftTypeOptions,
  currentUser
}) => {
  return (
    <div
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
      id="dark-header-modal"
      className="modal fade"
      aria-labelledby="create-rules-modal"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header modal-colored-header bg-dark">
            <HeaderTag
              type="h4"
              className="modal-title"
              id="create-rules-modal"
              title="Create New Rules"
            />
            <Button
              title="x"
              type="button"
              className="close"
              aria-hidden="true"
              data-dismiss="modal"
              isBackgroundColor={false}
            />
          </div>
          <form className="pl-3 pr-3" onSubmit={onCreateRulesSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6">
                  <SelectInput
                    required={true}
                    textWhite={false}
                    isLabeled={false}
                    onChange={onChange}
                    name="forLocation"
                    label="Select Location"
                    value={values.forLocation}
                  >
                    <option value="">Select Location</option>
                    {isSuperAdmin(currentUser)
                      ? renderLocationFunction(locations)
                      : renderAccessLocation2(
                          locationRender(currentUser, false)
                        )}
                  </SelectInput>
                </div>
                <div className="col-lg-6">
                  <SelectInput
                    required={true}
                    name="shiftType"
                    textWhite={false}
                    isLabeled={false}
                    onChange={onChange}
                    value={values.shiftType}
                    label="Select Shift Type"
                  >
                    <option value="">Select Shift Type</option>
                    {showShiftTypeOptions}
                  </SelectInput>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <HeaderTag
                    type="h5"
                    isClassName={false}
                    title={values.shiftType}
                    style={{ color: "#E0A802" }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <TextInput
                    type="time"
                    placeholder=""
                    name="shiftIn"
                    required={true}
                    textWhite={false}
                    htmlFor="shiftIn"
                    onChange={onChange}
                    label={inTimeString}
                    value={values.shiftIn}
                  />
                </div>
                <div className="col-lg-4">
                  <TextInput
                    type="time"
                    placeholder=""
                    required={true}
                    name="shiftOut"
                    textWhite={false}
                    htmlFor="shiftOut"
                    onChange={onChange}
                    label={outTimeString}
                    value={values.shiftOut}
                  />
                </div>
                <div className="col-lg-4">
                  <TextInput
                    type="number"
                    placeholder="Enter Buffer Time"
                    required={true}
                    name="bufferTime"
                    textWhite={false}
                    htmlFor="bufferTime"
                    onChange={onChange}
                    label="Buffer Time minute"
                    value={values.bufferTime}
                  />
                </div>
              </div>

              {/* leave */}
              <div className="row">
                <div className="col-lg-12">
                  <HeaderTag
                    type="h5"
                    title="Leaves"
                    isClassName={false}
                    style={{ color: "#E0A802" }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <TextInput
                    type="number"
                    required={true}
                    textWhite={false}
                    onChange={onChange}
                    name="privilegeLeaves"
                    label="Privilege Leave"
                    htmlFor="privilegeLeaves"
                    value={values.privilegeLeaves}
                    placeholder="Enter Privilege Leave"
                  />
                </div>
                <div className="col-lg-4">
                  <TextInput
                    type="number"
                    required={true}
                    textWhite={false}
                    name="needBasedLeaves"
                    onChange={onChange}
                    label="Need Based Leave"
                    htmlFor="needBasedLeaves"
                    value={values.needBasedLeaves}
                    placeholder="Enter Casual Leave"
                  />
                </div>
                {/* <div className="col-lg-4">
                  <TextInput
                    type="number"
                    required={true}
                    textWhite={false}
                    name="sickLeaves"
                    label="Sick Leave"
                    onChange={onChange}
                    htmlFor="sickLeaves"
                    value={values.sickLeaves}
                    placeholder="Enter Sick Leave"
                  />
                </div> */}
              </div>

              <div className="row">
                <div className="col-lg-3">
                  <TextInput
                    type="number"
                    required={true}
                    textWhite={false}
                    onChange={onChange}
                    label="Min Hours for H.D"
                    name="halfDayFloor"
                    htmlFor="halfDayFloor"
                    value={values.halfDayFloor}
                    placeholder="Enter Minimum Working Hours"
                  />
                </div>
                <div className="col-lg-3">
                  <TextInput
                    type="number"
                    required={true}
                    textWhite={false}
                    onChange={onChange}
                    label="Max Hours for H.D"
                    name="halfDayCeil"
                    htmlFor="halfDayCeil"
                    value={values.halfDayCeil}
                    placeholder="Enter Maximum Working Hours"
                  />
                </div>
                <div className="col-lg-3">
                  <TextInput
                    type="date"
                    required={true}
                    textWhite={false}
                    onChange={onChange}
                    name="activationDate"
                    label="Activation Date"
                    htmlFor="activationDate"
                    value={values.activationDate}
                    placeholder="Enter Activation Date"
                  />
                </div>
                <div className="col-lg-3">
                  <TextInput
                    type="date"
                    required={true}
                    textWhite={false}
                    name="willExpireOn"
                    onChange={onChange}
                    htmlFor="willExpireOn"
                    label="Expiration Date"
                    value={values.willExpireOn}
                    placeholder="Enter Expiration Date"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="button"
                title="Close"
                data-dismiss="modal"
                className="btn btn-light"
                isBackgroundColor={false}
              />
              {loading ? (
                <SpinnerButton />
              ) : (
                <Button
                  type="submit"
                  title="Create Rules"
                  className="btn btn-dark"
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

CreateRulesModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  inTimeString: PropTypes.string.isRequired,
  outTimeString: PropTypes.string.isRequired,
  onCreateRulesSubmit: PropTypes.func.isRequired,
  showShiftTypeOptions: PropTypes.array.isRequired
};

export default CreateRulesModal;
